"use client";

import { CallUs } from "@/types/dto/destinations-page/destination-page-types";
import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

export interface CallUsProps {
  callUs: CallUs | null;
}

export const CallUsComponent: React.FC<CallUsProps> = ({ callUs }) => {
  const [hover, setHover] = useState(false);  
  if (!callUs) return null;
  const { callUsText, phoneNumber } = callUs;
  return (
    <Box
      className="fluid-box"
      data-track="visibility"
      data-parent-container-type="cta"
      data-module-name="Call Us CTA"
      data-ranking-algorithm="manual"
      data-module-ranking-position="5"
      data-track-click="true"
      sx={{
        mx: "auto",
        backgroundColor: hover ? "background.cool" : "background.cool_strong",
        transition: "background-color 0.2s"
      }}
      data-testid="call-us-link"
      component="section"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        data-testid="call-us-container"
        className="destination-page-container"
        sx={{
          padding: "2.4rem",
          flexDirection: { legacyMobile: "column", legacyTablet: "column", legacyDesktop: "row" }
        }}
      >
        {callUsText && (
          <Typography
            variant="h4"
            component="h2"
            sx={{ 
              color: "primary.main",
              textAlign: { legacyMobile: "center", legacyTablet: "center", legacyDesktop: "center" },
              fontSize: { 
                legacyMobile: "20px", 
                legacyTablet: "20px", 
                legacyDesktop: "24px" 
              },
              fontWeight: 600,
              lineHeight: { 
                legacyMobile: "130%", 
                legacyTablet: "130%", 
                legacyDesktop: "normal" 
              },
              width: { legacyMobile: "100%", legacyTablet: "100%", legacyDesktop: "auto" }
            }}
            data-testid="call-us-text"
          >
            {callUsText}
          </Typography>
        )}

        {phoneNumber && (
          <Typography
            variant="h4"
            component="a"
            href={`tel:${phoneNumber}`}            
            data-testid="call-us-phone-link"
            className="phone-link"
            sx={{
              ml: { legacyMobile: 0, legacyTablet: 0, legacyDesktop: 1 },
              color: "primary.main",
              textAlign: { legacyMobile: "center", legacyTablet: "center", legacyDesktop: "center" },
              fontSize: { 
                legacyMobile: "20px", 
                legacyTablet: "20px", 
                legacyDesktop: "24px" 
              },
              fontWeight: 600,
              lineHeight: { 
                legacyMobile: "130%", 
                legacyTablet: "130%", 
                legacyDesktop: "normal" 
              },
              textDecoration: "underline",
              textDecorationStyle: "solid",
              textDecorationSkipInk: "none",
              width: { legacyMobile: "100%", legacyTablet: "100%", legacyDesktop: "auto" },
              "&:hover": {
                backgroundColor: "background.cool"
              }
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}               
          >
            {phoneNumber}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

